var defaultFeatureFlagOverrideUrl = '/static/no_cache/feature_flag_override.json';

var extractFeatureFlagData = function extractFeatureFlagData(jsonResponse) {
  var featureFlagOverrides = {};

  if (typeof jsonResponse === 'object') {
    for (var property in jsonResponse) {
      if (jsonResponse.hasOwnProperty(property)) {
        var featureFlagValue = jsonResponse[property];

        if (typeof featureFlagValue === 'boolean') {
          featureFlagOverrides[property] = featureFlagValue;
        }
      }
    }
  }

  return featureFlagOverrides;
};

var fetchFeatureFlagOverrides = function fetchFeatureFlagOverrides(_ref) {
  var environment = _ref.environment,
      _ref$featureFlagOverr = _ref.featureFlagOverrideUrl,
      featureFlagOverrideUrl = _ref$featureFlagOverr === void 0 ? defaultFeatureFlagOverrideUrl : _ref$featureFlagOverr;

  if (environment === 'development' && featureFlagOverrideUrl) {
    return fetch(featureFlagOverrideUrl, {
      method: 'GET',
      mode: 'cors'
    }).then(function (response) {
      return response.json();
    }).then(extractFeatureFlagData)["catch"](function (error) {
      console.error("error fetching the feature flag override values. Please consult the feature-flag-js package's README for more information.", error);
      return {};
    });
  }

  return Promise.resolve({});
};

export default fetchFeatureFlagOverrides;
//# sourceMappingURL=fetchFeatureFlagOverrides.esm.js.map
